import { FetchAPI, ToastNotificationAPI } from '@philips-emr/tws-components';
import { Value } from '@philips-emr/tws-core';
import { FetchEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HistoryService, HttpService } from '@philips-emr/tws-core/lib/services';
import { RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';

import { Endpoint } from '../constants';
import providerContext from '../context/provider-context';

const REVISION = 'R';
export class ProviderAccreditationPendenciesService {

  public static async getPendencies(nrSeqAccreditation: number, nrSeqProvider: number, type: string, steps?: string): Promise<RequestResponse<Record<string, Value>>> {
    const step = steps ? steps : '';
    return HttpService.get(Endpoint.GET.ACCREDITATION_PENDENCIES, { nrSeqAccreditation, nrSeqProvider, type, step });
  }

  public static fetchCardPendencies(event: MountEvent, step: string): void {
    const api = event.target as FetchAPI;
    const { nrSeqAccreditation } = HistoryService.getCurrentRouteParams();
    const nrSeqProvider = providerContext.getSelectedProvider().nrSeqProvider;
    api.setParameters({ nrSeqProvider, nrSeqAccreditation, step, type: REVISION });
    api.forceFetch();
  }

  public static setMessageToastPendency(toastApi: ToastNotificationAPI, event: FetchEvent): void {
    if (Array.isArray(event.data)) {
      const data = event.data[0];
      const { message } = data;
      toastApi.setMessage(message);
      toastApi.setVisible(true);
    }
  }
}
